import "./filterForm.css";
import React, { useEffect, useCallback, useMemo } from "react";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import OutlinedInput from "@mui/material/OutlinedInput";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import Autocomplete, {
  AutocompleteChangeReason,
} from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import { getFilterDropdowns } from "../../API/getFilterDropdowns";
import {
  saveFilterExceptionCodeData,
  saveAllExceptionCodeData,
  saveFilterCommodityTypeData,
  saveFilterDateData,
  saveFilterStatusData,
  saveFilterValueData,
  saveOveragesFilterForm,
  IFilterForm,
  TTerminal,
  IFilterDropdown,
  saveShortageExceptionCodeData,
  saveShortageStatusMaster,
  saveMyAssignmentStatusMaster,
  saveDamageStatusMaster,
  saveDamageExceptionCodeData,
  saveOnHandDeliveryExceptionCodeData,
  saveOnHandDeliveryStatusMaster,
  saveMisdeliveryExceptionCodeData,
  saveMisdeliveryStatusMaster,
} from "../../AppState/overagesFilterFormActions";
import {
  ALL_OSD_TYPES,
  APP,
  DAMAGE_OSD_TYPE,
  DType,
  EAutoSearchFieldName,
  ETab,
  FORM_STYLES,
  MAX_LENGTH_MANIFEST_NUMBER,
  MAX_LENGTH_PRO,
  MISDELIVERY_OSD_TYPES,
  ON_HAND_DELIVERY_OSD_TYPES,
  OVERAGE_OSD_TYPES,
  SHORTAGE_OSD_TYPES,
} from "../../constants";
import { getMasterProNumberAPI } from "../../API/getMasterProNumber";
import { getMasterOsdNumberAPI } from "../../API/getMasterOsdNumber";
import { commodityTypeMasterApi } from "../../API/getCommodityTypeMaster";
import { exceptionCodesMasterApi } from "../../API/getExceptionCodesMaster";
import _, { debounce } from "lodash";
import { saveMyAssignmentsFilterForm } from "../../AppState/myAssignmentsFilterFormActions";
import {
  saveDamagesPageObject,
  saveMisdeliveryPageObject,
  saveMyAssignmentPageObject,
  saveOnHandDeliveryPageObject,
  saveOverageListPageObject,
  saveSearchExceptionPageObject,
  saveShortagesPageObject,
} from "../../AppState/DataTableAction";
import { resetState, ResetType } from "../../AppState/resetStateActions";
import { GridPaginationModel } from "@mui/x-data-grid";
import {
  handlePaste,
  handleTextFieldKeyDown,
  noOptionsText,
} from "../../helpers";
import { saveShortagesFilterForm } from "../../AppState/shortagesFilterFormAction";
import { IMaterUser } from "../../models/user";
import {
  commodityMasterDataSelector,
  currentTerminalSelector,
  dateMasterSelector,
  exceptionCodesSelector,
  filterFromSelector,
  investigationStatusSelector,
  pageSelector,
  tabPositionSelector,
  terminalSelector,
  valueRangeSelector,
} from "../../AppState/selectors";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { saveDamagesFilterForm } from "../../AppState/damagesFilterFormAction";
import CustomIconComponent from "../CustomDropdownIcon";
import { saveOnHandDeliveryFilterForm } from "../../AppState/onHandDeliveryFilterFormAction";
import { saveMisdeliveryFilterForm } from "../../AppState/misdeliveryFilterFormAction";
import { saveExceptionSearchFilterForm } from "../../AppState/exceptionSearchFilterFromAction";
import TerminalAutocomplete from "./TerminalAutocomplete";
import UserAutocomplete from "./UserAutocomplete";

type Props = {
  onFilterSubmit?: () => void;
};
const SearchFilterForm: React.FC<Props> = (props: Props): JSX.Element => {
  const dispatch = useDispatch();
  const tabPosition = useSelector(tabPositionSelector);
  const currentTerminalValue = useSelector(currentTerminalSelector);
  const filterForm: IFilterForm = useSelector(filterFromSelector);

  const pageObject: GridPaginationModel | undefined = useSelector(pageSelector);

  const [date, setDate] = React.useState("");
  const valueRangeMasterData: IFilterDropdown[] =
    useSelector(valueRangeSelector);
  const investigationStatusMasterData: IFilterDropdown[] = useSelector(
    investigationStatusSelector
  );
  const overagesFilterDateData = useSelector(dateMasterSelector);
  const exceptionCodes = useSelector(exceptionCodesSelector);
  const commodityTypeMaster = useSelector(commodityMasterDataSelector);
  const terminalMaster = useSelector(terminalSelector);

  const handleChangeDate = (event: SelectChangeEvent) => {
    setFromDate("");
    setToDate("");
    setIsSearching(false);
    setDate(event.target.value);
  };
  const [tid, setTid] = React.useState<string[]>([]);
  const [did, setDid] = React.useState<string[]>([]);
  const [rTid, setRTid] = React.useState<string[]>([]);
  const [isSearching, setIsSearching] = React.useState<boolean>(false);

  const [cInputValue, setCInputValue] = React.useState<string>("");
  const [loading, setLoading] = React.useState<boolean>(true);

  const [fromDate, setFromDate] = React.useState<string>("");
  const [toDate, setToDate] = React.useState<string>("");

  const onAutoInputChange = (v: string, r: string, type: string = "") => {
    if (r === "input") {
      const setterMap: Record<string, (value: string) => void> = {
        commodity: setCInputValue,
      };

      setterMap[type]?.(v);
    }
  };

  const [exco, setExco] = React.useState<string[]>([]);
  const handleChangeExcep = (event: SelectChangeEvent<typeof exco>) => {
    const {
      target: { value },
    } = event;
    setExco(typeof value === "string" ? value.split(",") : value);
  };

  const [ctype, setCtype] = React.useState<string[]>([]);
  const handleChangeCommodityType = (value: string[]) => {
    setCtype(value);
  };

  const isMSD = tabPosition === ETab.misdelivery 

  const [value, setValue] = React.useState<string[]>([]);

  const handleChangeValue = (event: SelectChangeEvent<any>) => {
    const {
      target: { value },
    } = event;
    setValue(typeof value === "string" ? value.split(",") : value);
  };

  const [status, setStatus] = React.useState<string[]>([]);
  const handleStatusChange = (event: SelectChangeEvent<any>) => {
    const {
      target: { value },
    } = event;
    setStatus(typeof value === "string" ? value.split(",") : value);
  };

  const [description, setDescription] = React.useState<string | null>("");
  const [driverName, setDriverName] = React.useState<string | null>("");
  const [dockWorkerName, setDockWorkerName] = React.useState<string | null>("");
  const [consigneeName, setConsigneeName] = React.useState<string | null>("");
  const [shipperName, setShipperName] = React.useState<string | null>("");
  const [proEntry, setProEntry] = React.useState<string | null>("");
  const [od400ProEntry, setOD400ProEntry] = React.useState<string | null>("");
  const [osdNumber, setOSDNumber] = React.useState<string | null>("");
  const [entryUser, setEntryUser] = React.useState<any>("");
  const [assignUser, setAssignUser] = React.useState<any>("");
  const [assignBy, setAssignBy] = React.useState<any>("");

  const [proMasterData, setProMasterData] = React.useState<string[]>([]);
  const [od400ProMasterData, setOD400ProMasterData] = React.useState<string[]>(
    []
  );
  const [osdMasterData, setOsdMasterData] = React.useState<string[]>([]);
  type UserState = IMaterUser | null | undefined;
  const [assignUserObject, setAssignUserObject] =
    React.useState<UserState>(null);
  const [entryUserObject, setEntryUserObject] = React.useState<UserState>(null);
  const [assignByObject, setAssignByObject] = React.useState<UserState>(null);

  const onOSDexceptionChange = (
    value: string | null,
    reason?: AutocompleteChangeReason
  ) => {
    if (reason === "clear") setOsdMasterData([]);
    if (!value || value === "undefined") return;
    setOSDNumber(value);
  };

  const onPROentryChange = (
    value: string | null,
    reason?: AutocompleteChangeReason
  ) => {
    if (reason === "clear") setProMasterData([]);
    if (!value || value === "undefined") return;
    setProEntry(value);
  };

  const onOD400PROentryChange = (
    value: string | null,
    reason?: AutocompleteChangeReason
  ) => {
    if (reason === "clear") setOD400ProMasterData([]);
    if (!value || value === "undefined") return;
    setOD400ProEntry(value);
  };

  // Get terminal, Commodity exception codes, values, status Filter masters for Dropdown data API call
  const getSearchFiltersAPI = (ParamString: string) => {
    if (ParamString === "commodityType") {
      commodityTypeMasterApi()
        .then((results) => {
          const sortedData: IFilterDropdown[] = results.data
            .sort((a: any, b: any) => a.code - b.code)
            .map((a: IFilterDropdown) => {
              a.code = a?.code?.trim();
              return a;
            });
          dispatch(saveFilterCommodityTypeData(sortedData));
        })
        .catch((error) => {
          console.error(error);
        });
    } else if (ParamString === "Exception_Codes") {
      // get Exception code/type for overage list and myAssignment
      exceptionCodesMasterApi({
        dataType: (() => {
          const tabKeyMap = {
            [ETab.overages]: "overage",
            [ETab.myAssignments]: "myAssignment",
            [ETab.dashboard]: "myAssignment",
            [ETab.damages]: "damage",
            [ETab.onHandDelivery]: "onHandDelivery",
            [ETab.misdelivery]: "misDelivery",
            [ETab.shortages]: "shortage",
          };

          return (
            tabKeyMap[tabPosition as keyof typeof tabKeyMap] || "myAssignment"
          );
        })(),
      })
        .then((results) => {
          const dispatchMap = {
            [ETab.overages]: saveFilterExceptionCodeData,
            [ETab.myAssignments]: saveAllExceptionCodeData,
            [ETab.dashboard]: saveAllExceptionCodeData,
            [ETab.damages]: saveDamageExceptionCodeData,
            [ETab.shortages]: saveShortageExceptionCodeData,
            [ETab.onHandDelivery]: saveOnHandDeliveryExceptionCodeData,
            [ETab.misdelivery]: saveMisdeliveryExceptionCodeData,
          };

          const action =
            dispatchMap[tabPosition as keyof typeof dispatchMap] ||
            saveAllExceptionCodeData;
          dispatch(action(results));
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      let params: { dataType: string } = {
        dataType: ParamString,
      };
      // store date rage, search value  and status data in redux store.
      getFilterDropdowns(params)
        .then((results) => {
          switch (ParamString) {
            case "overageSearchDateRange": {
              const data = (results ?? []).sort(
                (a: IFilterDropdown, b: IFilterDropdown) =>
                  a.serialNumber! - b.serialNumber!
              );
              dispatch(saveFilterDateData(data));
              break;
            }
            case "overageSearchValues":
              dispatch(saveFilterValueData(results));
              break;
            case "overageStatus":
              dispatch(saveFilterStatusData(results));
              break;
            case "shortageStatus":
              dispatch(saveShortageStatusMaster(results));
              break;
            case "myAssignmentStatus":
              dispatch(saveMyAssignmentStatusMaster(results));
              break;
            case "damageStatus":
              dispatch(saveDamageStatusMaster(results));
              break;
            case "onHandDeliveryStatus":
              dispatch(saveOnHandDeliveryStatusMaster(results));
              break;
            case "misdeliveryStatus":
              dispatch(saveMisdeliveryStatusMaster(results));
              break;
            default:
              return "";
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  // Event fire on Entry user changes from Filter form and set entry user

  // Call API getMasterProNumberAPI method for get PRO numbers master options to filter Data on grid
  const getProMasterDataAPI = (values: string, proType: string = "normal") => {
    if (values?.length > 1) {
      let osdType: string;

      // Optimize osdType assignment based on tabPosition and proType
      if (
        [ETab.shortages, ETab.damages, ETab.onHandDelivery].includes(
          tabPosition
        )
      ) {
        osdType = exceptionCodes.join(",");
      } else {
        osdType = proType === DType.od400 ? "NB,OV" : ALL_OSD_TYPES.join(",");
      }
      const params: {
        search: string;
        page: number;
        limit: number;
        osdType: string;
        proType: string;
      } = {
        search: values.toString(),
        page: APP.overage.userAPIpageLimit,
        limit: APP.overage.userAPILimit,
        osdType: osdType,
        proType: proType,
      };

      getMasterProNumberAPI(params)
        .then((results: any) => {
          setLoading(false);
          if (proType === DType.od400) {
            setOD400ProMasterData(results?.data);
          } else {
            setProMasterData(results?.data);
          }
        })
        .catch((error) => {
          setLoading(false);
        });
    }
  };

  // Helper function to generate terminal list
  const getTerminalList = (
    currentTerminal: TTerminal,
    allTerminals: TTerminal[]
  ) => {
    // If currentTerminal?.region is undefined or null, return all terminals with the same region
    if (!currentTerminal?.region) {
      return allTerminals
        .filter((t) => t.region === currentTerminal.terminalId)
        .map((t) => t.terminalId);
    }

    // Otherwise, return an array containing only the current terminal's terminalId
    return [currentTerminal.terminalId];
  };

  // Memoize columnVisibilityModel, terminal list and exception type
  const terminalList = useMemo(
    () => getTerminalList(currentTerminalValue, terminalMaster),
    [currentTerminalValue, terminalMaster]
  );
  // Memoized destination and reporting based on tabPosition and terminal value
  const destination = useMemo(() => {
    // For shortages, damages and onHandDelivery, destination is terminal list
    if (
      [ETab.shortages, ETab.damages, ETab.onHandDelivery].includes(tabPosition)
    )
      return currentTerminalValue?.terminalId === "All" ? [] : terminalList;
    return [];
  }, [tabPosition, currentTerminalValue, terminalList]);

  const reporting = useMemo(() => {
    // For overages, reporting is always terminal list
    if (tabPosition === ETab.overages) {
      return currentTerminalValue?.terminalId === "All" ? [] : terminalList;
    }
    return [];
  }, [tabPosition, currentTerminalValue, terminalList]);

  // Call API getMasterOsdNumberAPI method for get exception numbers master options to filter Data on grid
  const getOsdMasterDataAPI = async (values: any) => {
    const isCodeEmpty = !exceptionCodes?.length;
    let osdTypes: string[];
    if (isCodeEmpty) {
      const osdTypeMap = {
        [ETab.overages]: OVERAGE_OSD_TYPES,
        [ETab.myAssignments]: ALL_OSD_TYPES,
        [ETab.dashboard]: ALL_OSD_TYPES,
        [ETab.damages]: DAMAGE_OSD_TYPE,
        [ETab.onHandDelivery]: ON_HAND_DELIVERY_OSD_TYPES,
        [ETab.misdelivery]: MISDELIVERY_OSD_TYPES,
      };

      osdTypes =
        osdTypeMap[tabPosition as keyof typeof osdTypeMap] ??
        SHORTAGE_OSD_TYPES;
    } else {
      osdTypes = exceptionCodes;
    }
    if (values?.length > 1) {
      let params: any = {
        search: values.toString(),
        page: APP.overage.userAPIpageLimit,
        limit: APP.overage.userAPILimit,
        osdType: osdTypes.join(","),
        destination: destination.join(","),
        reporting: reporting.join(","),
      };
      getMasterOsdNumberAPI(params)
        .then((results: any) => {
          setLoading(false);
          setOsdMasterData(results?.data);
        })
        .catch((error) => {
          setLoading(false);
          console.error(error);
        });
    }
  };

  const getErrorMessage = (value: string) => {
    if (date === "CUS" && !value && isSearching) {
      return <span className="form-error">Please select date</span>;
    }
    return null;
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounced = useCallback(
    debounce((value, type) => {
      if (type === DType.pro || type === DType.od400) {
        getProMasterDataAPI(value, type);
      } else if (type === DType.osd) {
        getOsdMasterDataAPI(value);
      }
    }, 1000),
    []
  );

  const onInputChange = (value: any, type: string) => {
    if (value === "undefined") return;

    const setterMap: Record<string, () => void> = {
      [DType.pro]: () => {
        setProEntry(value);
        setProMasterData([]);
      },
      [DType.od400]: () => {
        setOD400ProEntry(value);
        setOD400ProMasterData([]);
      },
      [DType.osd]: () => {
        setOSDNumber(value);
        setOsdMasterData([]);
      },
    };
    setterMap[type]?.();
    setLoading(true);
    debounced(value, type);
  };

  // Action perform on "Clear Filter" button click on Filter form reset all filter form value as initials
  const onFormClear = () => {
    const resetKeyMap: Record<number, ResetType> = {
      [ETab.overages]: "OSD_FILTER_RESET",
      [ETab.myAssignments]: "MY_ASSIGN_FILTER_RESET",
      [ETab.damages]: "DAMAGES_FILTER_RESET",
      [ETab.onHandDelivery]: "ON_HAND_DELIVERY_FILTER_RESET",
      [ETab.dashboard]: "DASHBOARD_SEARCH_FILTER_RESET",
      [ETab.misdelivery]: "MISDELIVERY_FILTER_RESET",
    };

    const resetKey = resetKeyMap[tabPosition] || "SHORTAGES_FILTER_RESET";
    dispatch(resetState(resetKey));

    if (props.onFilterSubmit) {
      props.onFilterSubmit();
    }
  };

  // Helper function to render text field
  const renderTextField = (
    label: string,
    id: string,
    value: string | null,
    onChange: (value: string) => void
  ) => (
    <Grid item md={3} xs={12}>
      <FormControl fullWidth size="small">
        <InputLabel style={FORM_STYLES.LABEL} shrink={true} htmlFor={id}>
          {label}
        </InputLabel>
        <TextField
          autoComplete="off"
          id={id}
          data-testid={id}
          onChange={(e) => onChange(e?.target?.value ?? "")}
          variant="outlined"
          value={value}
        />
      </FormControl>
    </Grid>
  );

  const onFormSubmit = () => {
    setIsSearching(true);
    if (date === "CUS" && (!toDate || !fromDate)) {
      return;
    }
    //// on filter form submit button updating redux store for manifest filter form
    //// maintaining same data for filter search, date and terminal picker
    if (props.onFilterSubmit) {
      props.onFilterSubmit();
    }

    const filterFormValues: IFilterForm = {
      search: filterForm.search,
      date,
      toDate,
      fromDate,
      origin: tid,
      destination: did,
      reporting: rTid,
      osdType: exco,
      commodityType: ctype,
      description: description?.toString()!,
      shipperName: shipperName,
      consigneeName: consigneeName,
      dockWorkerName: dockWorkerName,
      driverName: driverName,
      proNumber: proEntry?.toString()!,
      od400ProNumber: od400ProEntry?.toString()!,
      osdNumber: osdNumber?.toString()!,
      values: value,
      status,
      entryUser: entryUserObject?.nameFullLc
        ? entryUserObject
        : { as400Id: entryUser, nameFullLc: "" },
      assignedTo: assignUserObject?.as400Id
        ? assignUserObject
        : { as400Id: "", nameFullLc: assignUser },
      assignedBy: assignByObject?.as400Id
        ? assignByObject
        : { as400Id: "", nameFullLc: assignBy },
    };

    const page = { pageSize: _.get(pageObject, "pageSize"), page: 0 };

    const tabActions: Partial<Record<ETab, (page?: any) => void>> = {
      [ETab.overages]: () => {
        dispatch(saveOverageListPageObject(page));
        dispatch(saveOveragesFilterForm(filterFormValues));
      },
      [ETab.myAssignments]: () => {
        dispatch(saveMyAssignmentPageObject(page));
        dispatch(saveMyAssignmentsFilterForm(filterFormValues));
      },
      [ETab.shortages]: () => {
        dispatch(saveShortagesPageObject(page));
        dispatch(saveShortagesFilterForm(filterFormValues));
      },
      [ETab.damages]: () => {
        dispatch(saveDamagesPageObject(page));
        dispatch(saveDamagesFilterForm(filterFormValues));
      },
      [ETab.onHandDelivery]: () => {
        dispatch(saveOnHandDeliveryPageObject(page));
        dispatch(saveOnHandDeliveryFilterForm(filterFormValues));
      },
      [ETab.misdelivery]: () => {
        dispatch(saveMisdeliveryPageObject(page));
        dispatch(saveMisdeliveryFilterForm(filterFormValues));
      },
      [ETab.dashboard]: () => {
        dispatch(saveSearchExceptionPageObject(page));
        dispatch(saveExceptionSearchFilterForm(filterFormValues));
      },
    };

    // Execute the right set of actions if the tab exists
    tabActions[tabPosition as ETab]?.();
  };

  useEffect(() => {
    const mapping: Partial<Record<keyof IFilterForm, DType>> = {
      entryUser: DType.entryBy,
      assignedTo: DType.assignTo,
      assignedBy: DType.assignBy,
      proNumber: DType.pro,
      od400ProNumber: DType.od400,
      osdNumber: DType.osd,
    };

    Object.entries(mapping).forEach(([key, dtype]) => {
      const value = filterForm[key as keyof typeof filterForm];
      if (value) {
        onInputChange(value, dtype);
      }
    });
    // Set all filter form values from redux and maintain data as last visit of page filter with same session
    setDate(filterForm.date!);
    setTid(filterForm.origin!);
    setDid(filterForm.destination!);
    setRTid(filterForm.reporting!);
    setExco(filterForm.osdType!);
    setCtype(filterForm.commodityType!);
    setValue(filterForm.values!);
    setStatus(filterForm.status!);
    setToDate(filterForm.toDate ?? "");
    setFromDate(filterForm.fromDate ?? "");
    setDescription(
      filterForm.description ? filterForm?.description.trim() : ""
    );
    setConsigneeName(
      filterForm.consigneeName ? filterForm?.consigneeName.trim() : ""
    );
    setDockWorkerName(
      filterForm.dockWorkerName ? filterForm?.dockWorkerName.trim() : ""
    );
    setDriverName(filterForm.driverName ? filterForm?.driverName.trim() : "");

    setShipperName(
      filterForm.shipperName ? filterForm?.shipperName.trim() : ""
    );
    setProEntry(filterForm.proNumber);
    setOD400ProEntry(filterForm.od400ProNumber);
    setOSDNumber(filterForm.osdNumber);
    setEntryUserObject(filterForm.entryUser);
    setAssignUserObject(filterForm.assignedTo);
    setAssignByObject(filterForm.assignedBy);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabPosition, filterForm]);

  useEffect(() => {
    if (!commodityTypeMaster?.length) {
      getSearchFiltersAPI("commodityType");
    }
    if (!exceptionCodes?.length) {
      getSearchFiltersAPI("Exception_Codes");
    }
    if (!overagesFilterDateData?.length) {
      getSearchFiltersAPI("overageSearchDateRange");
    }
    if (!valueRangeMasterData?.length) {
      getSearchFiltersAPI("overageSearchValues");
    }
    if (!investigationStatusMasterData?.length) {
      const statusMap = {
        [ETab.shortages]: "shortageStatus",
        [ETab.overages]: "overageStatus",
        [ETab.damages]: "damageStatus",
        [ETab.onHandDelivery]: "onHandDeliveryStatus",
        [ETab.misdelivery]: "misdeliveryStatus",
      };

      getSearchFiltersAPI(
        statusMap[tabPosition as keyof typeof statusMap] ?? "myAssignmentStatus"
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="parent-filter">
      <div className="filter">
        <Grid container spacing={2} className="filter-margin">
          <Grid item md={3} xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel style={FORM_STYLES.LABEL} shrink={true} id="date">
                Date
              </InputLabel>
              <Select
                variant="outlined"
                id="date"
                data-testid="date-select"
                placeholder="Select a Date"
                className="select"
                value={date}
                fullWidth
                onChange={handleChangeDate}
                style={FORM_STYLES.LABEL}
                IconComponent={CustomIconComponent}
              >
                {overagesFilterDateData.map((obj: IFilterDropdown) => (
                  <MenuItem
                    style={FORM_STYLES.LABEL}
                    key={obj?.actualValue}
                    value={obj?.actualValue}
                  >
                    {obj?.displayValue}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          {/* Conditionally render From Date and To Date */}
          {date === "CUS" && (
            <>
              <Grid item md={3} xs={12}>
                <FormControl fullWidth size="small">
                  <InputLabel
                    style={FORM_STYLES.LABEL}
                    shrink={true}
                    id="from-date-label"
                  >
                    From Date
                  </InputLabel>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      value={dayjs(fromDate ?? null)}
                      onChange={(value) => {
                        if (value?.format("YYYY-MM-DD") !== "Invalid Date") {
                          setFromDate(value?.format("YYYY-MM-DD") ?? "");
                        }
                      }}
                      format="MM/DD/YYYY"
                      disableFuture
                      slotProps={{
                        textField: {
                          size: "small",
                          fullWidth: true,
                          error: false,
                          inputProps: { "data-testid": "from-date-picker" },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </FormControl>
                {getErrorMessage(fromDate)}
              </Grid>

              <Grid item md={3} xs={12}>
                <FormControl fullWidth size="small">
                  <InputLabel
                    style={FORM_STYLES.LABEL}
                    shrink={true}
                    id="to-date-label"
                  >
                    To Date
                  </InputLabel>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      value={dayjs(toDate ?? null)}
                      onChange={(value) => {
                        if (value?.format("YYYY-MM-DD") !== "Invalid Date") {
                          setToDate(value?.format("YYYY-MM-DD") ?? "");
                        }
                      }}
                      format="MM/DD/YYYY"
                      disableFuture
                      minDate={dayjs(fromDate ?? null)}
                      disabled={!fromDate}
                      slotProps={{
                        textField: {
                          size: "small",
                          fullWidth: true,
                          error: false,
                          inputProps: { "data-testid": "to-date-picker" },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </FormControl>
                {getErrorMessage(toDate)}
              </Grid>
            </>
          )}
          <TerminalAutocomplete
            tabPosition={tabPosition}
            tid={tid}
            setTid={setTid}
            did={did}
            setDid={setDid}
            rTid={rTid}
            setRTid={setRTid}
          />
          <Grid item md={3} xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel
                style={FORM_STYLES.LABEL}
                shrink={true}
                id="exceptionCode-label"
                htmlFor="exceptionCode"
              >
                Exception Code
              </InputLabel>
              <Select
                labelId="exceptionCode-label"
                id="exceptionCode"
                multiple
                className="select"
                value={exco}
                onChange={handleChangeExcep}
                style={FORM_STYLES.LABEL}
                input={<OutlinedInput label="Tag" />}
                renderValue={(selected) => selected.join(", ")}
                IconComponent={CustomIconComponent}
              >
                {exceptionCodes.map((obj) => (
                  <MenuItem className="font-override" key={obj} value={obj}>
                    <Checkbox checked={exco.includes(obj)} />
                    <ListItemText className="font-override" primary={obj} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          {!isMSD && (
            <Grid item md={3} xs={12} className="hide-no-option">
              <FormControl fullWidth size="small">
                <InputLabel
                  style={FORM_STYLES.LABEL}
                  shrink={true}
                  htmlFor="commodityType"
                >
                  Commodity
                </InputLabel>
                <Autocomplete
                  id="commodityType"
                  key="search-ctype"
                  className="custom-autocomplete"
                  disablePortal
                  multiple
                  getOptionLabel={(option) =>
                    typeof option === "string"
                      ? option
                      : `${option.displayValue} - ${option.code}`
                  }
                  value={commodityTypeMaster.filter((item) =>
                    ctype.includes(item.displayValue)
                  )}
                  inputValue={cInputValue}
                  onClose={(e) => {
                    setCInputValue("");
                  }}
                  onInputChange={(e, v, r) =>
                    onAutoInputChange(v, r, "commodity")
                  }
                  forcePopupIcon={false}
                  options={commodityTypeMaster}
                  isOptionEqualToValue={(option, value) =>
                    option.displayValue === value.displayValue
                  }
                  disableCloseOnSelect
                  onChange={(e, v) => {
                    handleChangeCommodityType(v.map((item) => item.displayValue));
                    setCInputValue("");
                  }}
                  renderOption={(props, option) => (
                    <li {...props} title={`${option.displayValue} - ${option.code}`}>
                      <Checkbox
                        checked={ctype.includes(option.displayValue)}
                      />
                      {`${option.displayValue} - ${option.code}`}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      autoComplete="off"
                      {...params}
                      variant="outlined"
                    />
                  )}
                  renderTags={(value) => (
                    <div
                      className="auto-complete-selected-container"
                      title={value.map((item) => `${item.displayValue} - ${item.code}`).join(", ")}
                    >
                      {value.map((item) => `${item.displayValue} - ${item.code}`).join(", ")}
                    </div>
                  )} // Add renderTags property to customize rendering of selected values
                />
              </FormControl>
            </Grid>
          )}
          {renderTextField(
            "Description",
            "description",
            description,
            setDescription
          )}
          <Grid item md={3} xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel style={FORM_STYLES.LABEL} shrink={true} htmlFor="pro">
                PRO #
              </InputLabel>
              <Autocomplete
                id="pro"
                key="search-proEntry"
                disablePortal
                noOptionsText={noOptionsText(
                  proEntry!,
                  loading,
                  EAutoSearchFieldName.pro
                )}
                size="small"
                value={proEntry}
                onInputChange={(e, v) => {
                  if (typeof v !== "string") {
                    return;
                  }
                  if (v.length <= MAX_LENGTH_PRO) {
                    // Restrict input to maxLength
                    onInputChange(v, DType.pro);
                  }
                }}
                onChange={(e, v, r) => onPROentryChange(v, r)}
                forcePopupIcon={false}
                className="autocomplete"
                getOptionLabel={(option) => option}
                inputValue={proEntry!}
                options={proMasterData}
                renderInput={(params) => (
                  <TextField
                    onKeyDown={handleTextFieldKeyDown}
                    onPaste={handlePaste}
                    autoComplete="off"
                    {...params}
                  />
                )}
              />
            </FormControl>
          </Grid>
          {[ETab.myAssignments, ETab.dashboard, ETab.overages, ETab.misdelivery].includes(
            tabPosition
          ) && (
            <Grid item md={3} xs={12}>
              <FormControl fullWidth size="small">
                <InputLabel
                  style={FORM_STYLES.LABEL}
                  shrink={true}
                  id="od400Pro-label"
                  htmlFor="od400Pro"
                >
                  OD400 PRO #
                </InputLabel>
                <Autocomplete
                  id="od400Pro"
                  key="search-od400ProEntry"
                  disablePortal
                  noOptionsText={noOptionsText(
                    od400ProEntry!,
                    loading,
                    EAutoSearchFieldName.od400
                  )}
                  size="small"
                  value={od400ProEntry}
                  onInputChange={(e, v) => {
                    if (typeof v !== "string") {
                      return;
                    }
                    if (v.length <= MAX_LENGTH_PRO) {
                      onInputChange(v, DType.od400);
                    }
                  }}
                  onChange={(e, v, r) => onOD400PROentryChange(v, r)}
                  forcePopupIcon={false}
                  className="autocomplete"
                  getOptionLabel={(option) => option || ""}
                  inputValue={od400ProEntry!}
                  options={od400ProMasterData}
                  renderInput={(params) => (
                    <TextField
                      onKeyDown={handleTextFieldKeyDown}
                      onPaste={handlePaste}
                      autoComplete="off"
                      {...params}
                    />
                  )}
                />
              </FormControl>
            </Grid>
          )}{" "}
          {!isMSD && renderTextField(
            "Shipper Name",
            "shipperName",
            shipperName,
            setShipperName
          )}
          {!isMSD && renderTextField(
            "Consignee Name",
            "consigneeName",
            consigneeName,
            setConsigneeName
          )}
          <Grid item md={3} xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel
                style={FORM_STYLES.LABEL}
                shrink={true}
                id="osdNumber-label"
                htmlFor="osdNumber"
              >
                Exception #
              </InputLabel>
              <Autocomplete
                id="osdNumber"
                disablePortal
                size="small"
                noOptionsText={noOptionsText(
                  osdNumber!,
                  loading,
                  EAutoSearchFieldName.osdNumber
                )}
                key="search-osdNumber"
                value={osdNumber}
                onInputChange={(e, v) => {
                  if (typeof v !== "string") {
                    return;
                  }
                  if (v.length <= MAX_LENGTH_MANIFEST_NUMBER) {
                    onInputChange(v, DType.osd);
                  }
                }}
                onChange={(e, v, r) => onOSDexceptionChange(v, r)}
                forcePopupIcon={false}
                className="autocomplete"
                inputValue={osdNumber!}
                getOptionLabel={(option) => option}
                options={osdMasterData}
                renderInput={(params) => (
                  <TextField
                    onKeyDown={handleTextFieldKeyDown}
                    onPaste={handlePaste}
                    autoComplete="off"
                    {...params}
                  />
                )}
              />
            </FormControl>
          </Grid>
          { !isMSD && <Grid item md={3} xs={12}>
            <FormControl fullWidth size="small">
                  <InputLabel
                    style={FORM_STYLES.LABEL}
                    shrink={true}
                    id="value-label"
                    htmlFor="value"
                  >
                Value Range
              </InputLabel>
              <Select
                    labelId="value-label"
                id="value"
                multiple
                className="select"
                value={value}
                onChange={handleChangeValue}
                style={FORM_STYLES.LABEL}
                input={<OutlinedInput label="Tag" />}
                renderValue={(selected) => selected.join(", ")}
                IconComponent={CustomIconComponent}
              >
                {valueRangeMasterData.map((obj: IFilterDropdown) => (
                  <MenuItem
                    className="font-override"
                    key={obj.displayValue}
                    value={obj.actualValue}
                  >
                    <Checkbox checked={value.includes(obj.actualValue)} />
                    <ListItemText
                      className="font-override"
                      primary={obj.displayValue}
                    />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
}
          <Grid item md={3} xs={12}>
            <FormControl fullWidth size="small">
              <InputLabel
                style={FORM_STYLES.LABEL}
                shrink={true}
                id="status-label"
                htmlFor="status"
              >
                Status
              </InputLabel>
              <Select
                labelId="status-label"
                id="status"
                multiple
                className="select"
                value={status}
                onChange={handleStatusChange}
                style={FORM_STYLES.LABEL}
                input={<OutlinedInput label="Tag" />}
                renderValue={(selected) =>
                  investigationStatusMasterData
                    .filter((obj) => selected.includes(obj.actualValue))
                    .map((obj) => obj.displayValue)
                    .join(", ")
                }
                IconComponent={CustomIconComponent}
              >
                {investigationStatusMasterData.map((obj: IFilterDropdown) => (
                  <MenuItem
                    className="font-override"
                    key={obj.displayValue}
                    value={obj.actualValue}
                  >
                    <Checkbox checked={status.includes(obj.actualValue)} />
                    <ListItemText
                      className="font-override"
                      primary={obj.displayValue}
                    />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <UserAutocomplete
            tabPosition={tabPosition}
            entryUser={entryUser}
            setEntryUser={setEntryUser}
            setEntryUserObject={setEntryUserObject}
            assignUser={assignUser}
            setAssignUser={setAssignUser}
            setAssignUserObject={setAssignUserObject}
            assignBy={assignBy}
            setAssignBy={setAssignBy}
            setAssignByObject={setAssignByObject}
            loading={loading}
            setLoading={setLoading}
            entryUserObject={entryUserObject}
            assignUserObject={assignUserObject}
            assignByObject={assignByObject}
          />
          {[ETab.myAssignments, ETab.dashboard, ETab.misdelivery].includes(tabPosition) && (
            <>
              {renderTextField(
                "Driver's Name",
                "driverName",
                driverName,
                setDriverName
              )}
              {renderTextField(
                "Dock Worker's Name",
                "dockWorkerName",
                dockWorkerName,
                setDockWorkerName
              )}
            </>
          )}
          <Grid
            item
            md={12}
            xs={12}
            display="flex"
            justifyContent="flex-end"
            className="filter-margin"
          >
            <Button onClick={onFormClear} variant="text" className="clear-link">
              Clear Filter
            </Button>
            <Button
              onClick={onFormSubmit}
              variant="contained"
              className="submit"
            >
              Search
            </Button>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default SearchFilterForm;
